export enum CCorrectLevel {

  /**
   * 纠错等级：L
   */
  L = 'L',
  /**
   * 纠错等级：M
   */
  M = 'M',
  /**
   * 纠错等级：Q
   */
  Q = 'Q',
  /**
   * 纠错等级：H
   */
  H = 'H',
}
